import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'ILN';
render(<App data-id="element-531" />, document.getElementById('root'));